import { Component, OnInit } from '@angular/core';
import gsap from 'gsap';

@Component({
  selector: 'app-anim-backbone',
  templateUrl: './anim-backbone.component.html',
  styleUrls: ['./anim-backbone.component.scss']
})
export class AnimBackboneComponent implements OnInit {
  tlBackbone = gsap.timeline({ repeat: -1 });
  paths = [
    { name: '.path.merak-rangkasbitung', length: 57 },
    { name: '.path.rangkasbitung-cisauk', length: 45 },
    { name: '.path.cisauk-gambir', length: 33 },
    { name: '.path.gambir-bogor', length: 48 },
    { name: '.path.bogor-sukabumi', length: 66 },
    { name: '.path.sukabumi-bandung', length: 95 },
    { name: '.path.bandung-tasikmalaya', length: 121 },
    { name: '.path.tasikmalaya-cilacap', length: 102 },
    { name: '.path.cilacap-kutoarjo', length: 125 },
    { name: '.path.kutoarjo-tugujogja', length: 73 },
    { name: '.path.tugujogja-klaten', length: 36 },
    { name: '.path.klaten-solobalapan', length: 33 },
    { name: '.path.solobalapan-madiun', length: 94 },
    { name: '.path.madiun-nganjuk', length: 50 },
    { name: '.path.nganjuk-kediri', length: 49 },
    { name: '.path.kediri-tulungagung', length: 45 },
    { name: '.path.tulungagung-malang', length: 110 },
    { name: '.path.malang-sidoarjo', length: 45 },
    { name: '.path.nganjuk-pasarturi', length: 83 },
    { name: '.path.gambir-cikampek', length: 79 },
    { name: '.path.cikampek-cirebon', length: 134 },
    { name: '.path.cirebon-tegal', length: 88 },
    { name: '.path.tegal-pekalongan', length: 85 },
    { name: '.path.pekalongan-semarangtawang', length: 82 },
    { name: '.path.semarangtawang-pasarturi', length: 284 },
    { name: '.path.semarangtawang-solobalapan', length: 87 },
    { name: '.path.cikampek-purwakarta', length: 23 },
    { name: '.path.purwakarta-bandung', length: 31 },
    { name: '.path.pasarturi-sidoarjo', length: 25 },
    { name: '.path.sidoarjo-pasuruan', length: 43 },
    { name: '.path.pasuruan-probolinggo', length: 49 },
    { name: '.path.probolinggo-jember', length: 97 },
    { name: '.path.jember-banyuwangi', length: 90 },
    { name: '.path.cirebon-cilacap', length: 182 },
  ]

  constructor() { }

  ngOnInit(): void {
    // let tl = gsap.timeline({ repeat: -1 });
    this.tlBackbone.add(this.hidePath());
    this.tlBackbone.add(this.showPath());
  }

  ngOnDestroy(): void{
    this.tlBackbone.kill();
  }

  showPath() {
    let tl = gsap.timeline();

    tl.addLabel('start');
    tl.add(this.animatePath('show', 'merak-rangkasbitung'), 'start').addLabel('endMerakRangkas');
    tl.add(this.animatePath('show', 'rangkasbitung-cisauk'), 'endMerakRangkas').addLabel('endRangkasCisauk');
    tl.add(this.animatePath('show', 'cisauk-gambir'), 'endRangkasCisauk').addLabel('endCisaukGambir');
    tl.add(this.animatePath('show', 'gambir-bogor'), 'endCisaukGambir').addLabel('endGambirBogor');
    tl.add(this.animatePath('show', 'bogor-sukabumi'), 'endGambirBogor').addLabel('endBogorSukabumi');
    tl.add(this.toggleLabel('show', 'merak', null, -4), 'start');
    tl.add(this.toggleLabel('show', 'rangkasbitung', -5), 'endMerakRangkas');
    tl.add(this.toggleLabel('show', 'cisauk', -4), 'endRangkasCisauk');
    tl.add(this.toggleLabel('show', 'gambir', null, -4), 'endCisaukGambir');
    tl.add(this.toggleLabel('show', 'bogor', 3), 'endGambirBogor');
    tl.add(this.toggleLabel('show', 'sukabumi', null, 5), 'endBogorSukabumi');

    tl.add(this.animatePath('show', 'gambir-cikampek', 0.05), 'endBogorSukabumi-=0.05').addLabel('endGambirCikampek');
    tl.add(this.animatePath('show', 'cikampek-purwakarta', 0.025), 'endGambirCikampek').addLabel('endCikampekPurwakarta');
    tl.add(this.animatePath('show', 'purwakarta-bandung', 0.025), 'endCikampekPurwakarta').addLabel('endPurwakartaBandung');
    tl.add(this.animatePath('show', 'sukabumi-bandung'), 'endBogorSukabumi').addLabel('endSukabumiBandung');
    tl.add(this.toggleLabel('show', 'cikampek', null, -3), 'endGambirCikampek');
    tl.add(this.toggleLabel('show', 'purwakarta', 3), 'endCikampekPurwakarta');
    tl.add(this.toggleLabel('show', 'bandung', null, 3), 'endPurwakartaBandung');

    tl.add(this.animatePath('show', 'bandung-tasikmalaya'), 'endSukabumiBandung').addLabel('endBandungTasik');
    tl.add(this.animatePath('show', 'tasikmalaya-cilacap'), 'endBandungTasik').addLabel('endTasikCilacap');
    tl.add(this.animatePath('show', 'cikampek-cirebon'), 'endGambirCikampek').addLabel('endCikampekCirebon');
    tl.add(this.animatePath('show', 'cirebon-cilacap', 0.2), 'endCikampekCirebon').addLabel('endCirebonCilacap');
    tl.add(this.toggleLabel('show', 'cirebon', null, -3), 'endCikampekCirebon');
    tl.add(this.toggleLabel('show', 'tasikmalaya', null, 4), 'endBandungTasik');
    tl.add(this.toggleLabel('show', 'cilacap', -3), 'endTasikCilacap');

    tl.add(this.animatePath('show', 'cilacap-kutoarjo'), 'endTasikCilacap').addLabel('endCilacapKutoarjo');
    tl.add(this.animatePath('show', 'cirebon-tegal'), 'endCikampekCirebon').addLabel('endCirebonTegal');
    tl.add(this.toggleLabel('show', 'kutoarjo', null, -3), 'endCilacapKutoarjo');
    tl.add(this.toggleLabel('show', 'tegal', null, -5), 'endCirebonTegal');

    tl.add(this.animatePath('show', 'kutoarjo-tugujogja'), 'endCilacapKutoarjo').addLabel('endKutoarjoTugujogja');
    tl.add(this.animatePath('show', 'tegal-pekalongan', 0.15), 'endCirebonTegal').addLabel('endTegalPekalongan');
    tl.add(this.toggleLabel('show', 'tugujogja', 3), 'endKutoarjoTugujogja');
    tl.add(this.toggleLabel('show', 'pekalongan', null, -5), 'endTegalPekalongan');

    tl.add(this.animatePath('show', 'tugujogja-klaten'), 'endKutoarjoTugujogja').addLabel('endTugujogjaKlaten');
    tl.add(this.animatePath('show', 'pekalongan-semarangtawang'), 'endTegalPekalongan').addLabel('endPekalonganSemarang');
    tl.add(this.toggleLabel('show', 'klaten', -4), 'endTugujogjaKlaten');
    tl.add(this.toggleLabel('show', 'semarangtawang', null, -5), 'endPekalonganSemarang');

    tl.add(this.animatePath('show', 'klaten-solobalapan'), 'endTugujogjaKlaten').addLabel('endKlatenSolo');
    tl.add(this.animatePath('show', 'semarangtawang-solobalapan'), 'endPekalonganSemarang').addLabel('endSemarangSolo');
    tl.add(this.toggleLabel('show', 'solobalapan', -4), 'endKlatenSolo-=0.05');

    tl.add(this.animatePath('show', 'solobalapan-madiun', 0.2), 'endKlatenSolo').addLabel('endSoloMadiun');
    tl.add(this.animatePath('show', 'semarangtawang-pasarturi', 0.5), 'endPekalonganSemarang').addLabel('endSemarangTuri');
    tl.add(this.animatePath('show', 'madiun-nganjuk'), 'endSoloMadiun').addLabel('endMadiunNganjuk');
    tl.add(this.toggleLabel('show', 'pasarturi', 4), 'endSemarangTuri');
    tl.add(this.toggleLabel('show', 'madiun', null, 2), 'endSoloMadiun');
    tl.add(this.toggleLabel('show', 'nganjuk', null, -3), 'endMadiunNganjuk');

    tl.add(this.animatePath('show', 'nganjuk-pasarturi', 0.2), 'endMadiunNganjuk').addLabel('endNganjukTuri');
    tl.add(this.animatePath('show', 'pasarturi-sidoarjo'), 'endSemarangTuri').addLabel('endTuriSidoarjo');
    tl.add(this.animatePath('show', 'nganjuk-kediri'), 'endMadiunNganjuk').addLabel('endNganjukKediri');
    tl.add(this.toggleLabel('show', 'sidoarjo'), 'endNganjukTuri');
    tl.add(this.toggleLabel('show', 'kediri', 5), 'endNganjukKediri');

    tl.add(this.animatePath('show', 'kediri-tulungagung'), 'endNganjukKediri').addLabel('endKediriTulungagung');
    tl.add(this.animatePath('show', 'sidoarjo-pasuruan'), 'endTuriSidoarjo').addLabel('endSidoarjoPasuruan');
    tl.add(this.toggleLabel('show', 'tulungagung', -4), 'endKediriTulungagung');
    tl.add(this.toggleLabel('show', 'pasuruan'), 'endSidoarjoPasuruan');

    tl.add(this.animatePath('show', 'tulungagung-malang', 0.2), 'endKediriTulungagung').addLabel('endTulungagungMalang');
    tl.add(this.animatePath('show', 'pasuruan-probolinggo'), 'endSidoarjoPasuruan').addLabel('endPasuruanProbolinggo');
    tl.add(this.toggleLabel('show', 'malang', null, -1), 'endTulungagungMalang');
    tl.add(this.toggleLabel('show', 'probolinggo'), 'endPasuruanProbolinggo');

    tl.add(this.animatePath('show', 'malang-sidoarjo'), 'endTulungagungMalang').addLabel('endMalangSidoarjo');
    tl.add(this.animatePath('show', 'probolinggo-jember'), 'endPasuruanProbolinggo').addLabel('endProbolinggoJember');
    tl.add(this.animatePath('show', 'jember-banyuwangi'), 'endProbolinggoJember').addLabel('endJemberBanyuwangi');
    tl.add(this.toggleLabel('show', 'jember'), 'endProbolinggoJember');
    tl.add(this.toggleLabel('show', 'banyuwangi'), 'endJemberBanyuwangi');

    tl.to('.label.merak', { opacity: 1, duration: 2 });
    return tl;
  }

  hidePath() {
    let tl = gsap.timeline();

    tl.addLabel('start');
    tl.add(this.toggleLabel('hide', 'merak', null, 4), 'start');
    tl.add(this.toggleLabel('hide', 'gambir', null, 4), 'start');
    tl.add(this.animatePath('hide', 'merak-rangkasbitung', 0.5), 'start').addLabel('endMerakRangkas');
    tl.add(this.animatePath('hide', 'gambir-cikampek', 0.2), 'start').addLabel('endGambirCikampek');

    tl.add(this.toggleLabel('hide', 'rangkasbitung', 5), 'start+=0.2');
    tl.add(this.toggleLabel('hide', 'cikampek', null, 3), 'start+=0.2');
    tl.add(this.toggleLabel('hide', 'purwakarta', -3), 'start+=0.2');
    tl.add(this.toggleLabel('hide', 'cisauk', 4), 'start+=0.4');
    tl.add(this.animatePath('hide', 'rangkasbitung-cisauk', 0.2), 'endMerakRangkas').addLabel('endRangkasCisauk');
    tl.add(this.animatePath('hide', 'cikampek-purwakarta'), 'start+=0.1').addLabel('endCikampekPurwakarta');
    tl.add(this.animatePath('hide', 'cisauk-gambir'), 'endRangkasCisauk').addLabel('endCisaukGambir');
    tl.add(this.animatePath('hide', 'purwakarta-bandung', 0.2), 'endCikampekPurwakarta').addLabel('endPurwakartaBandung');

    tl.add(this.toggleLabel('hide', 'bogor', -3), 'start+=0.8');
    tl.add(this.toggleLabel('hide', 'sukabumi', null, -5), 'start+=1');
    tl.add(this.animatePath('hide', 'gambir-bogor', 0.3), 'endCisaukGambir').addLabel('endGambirBogor');
    tl.add(this.animatePath('hide', 'bogor-sukabumi', 0.2), 'endGambirBogor').addLabel('endBogorSukabumi');

    tl.add(this.toggleLabel('hide', 'bandung', null, -3), 'start+=1.2');
    tl.add(this.toggleLabel('hide', 'cirebon', null, 3), 'start+=0.4');
    tl.add(this.animatePath('hide', 'cikampek-cirebon', 0.4), 'endGambirCikampek').addLabel('endCikampekCirebon');
    tl.add(this.animatePath('hide', 'cirebon-cilacap', 0.3), 'endCikampekCirebon').addLabel('endCirebonCilacap');
    tl.add(this.animatePath('hide', 'cirebon-tegal'), 'endCikampekCirebon').addLabel('endCirebonTegal');
    tl.add(this.animatePath('hide', 'sukabumi-bandung', 0.2), 'endBogorSukabumi').addLabel('endSukabumiBandung');
    
    tl.add(this.toggleLabel('hide', 'tegal', null, 5), 'start+=0.7');
    tl.add(this.toggleLabel('hide', 'pekalongan', null, 5), 'start+=1.2');
    tl.add(this.toggleLabel('hide', 'semarangtawang', null, 5), 'start+=1.4');
    tl.add(this.animatePath('hide', 'tegal-pekalongan', 0.2), 'endCirebonTegal').addLabel('endTegalPekalongan');
    tl.add(this.animatePath('hide', 'pekalongan-semarangtawang', 0.3), 'endTegalPekalongan').addLabel('endPekalonganSemarang');

    tl.add(this.toggleLabel('hide', 'tasikmalaya', null, -4), 'start+=1.6');
    tl.add(this.toggleLabel('hide', 'cilacap', 3), 'start+=1.8');
    tl.add(this.animatePath('hide', 'bandung-tasikmalaya', 0.4), 'endSukabumiBandung').addLabel('endBandungTasik');
    tl.add(this.animatePath('hide', 'tasikmalaya-cilacap', 0.3), 'endBandungTasik').addLabel('endTasikCilacap');
    tl.add(this.animatePath('hide', 'semarangtawang-solobalapan', 0.3), 'endPekalonganSemarang').addLabel('endSemarangSolo');

    tl.add(this.toggleLabel('hide', 'kutoarjo', null, 3), 'start+=2');
    tl.add(this.toggleLabel('hide', 'tugujogja', -3), 'start+=2.2');
    tl.add(this.animatePath('hide', 'cilacap-kutoarjo', 0.3), 'endTasikCilacap').addLabel('endCilacapKutoarjo');
    tl.add(this.animatePath('hide', 'kutoarjo-tugujogja', 0.2), 'endCilacapKutoarjo').addLabel('endKutoarjoTugujogja');

    tl.add(this.toggleLabel('hide', 'solobalapan', 4), 'start+=2.6');
    tl.add(this.toggleLabel('hide', 'klaten', 4), 'start+=2.7');
    tl.add(this.animatePath('hide', 'tugujogja-klaten'), 'endKutoarjoTugujogja').addLabel('endTugujogjaKlaten');
    tl.add(this.animatePath('hide', 'klaten-solobalapan'), 'endTugujogjaKlaten').addLabel('endKlatenSolo');

    tl.add(this.toggleLabel('hide', 'pasarturi', -4), 'start+=2.7');
    tl.add(this.toggleLabel('hide', 'madiun', null, -2), 'start+=2.9');
    tl.add(this.toggleLabel('hide', 'nganjuk', null, 3), 'start+=3');
    tl.add(this.animatePath('hide', 'semarangtawang-pasarturi', 1), 'endPekalonganSemarang').addLabel('endSemarangTuri');
    tl.add(this.animatePath('hide', 'solobalapan-madiun', 0.2), 'endKlatenSolo').addLabel('endSoloMadiun');
    tl.add(this.animatePath('hide', 'madiun-nganjuk'), 'endSoloMadiun').addLabel('endMadiunNganjuk');
    tl.add(this.animatePath('hide', 'nganjuk-pasarturi', 0.2), 'endMadiunNganjuk').addLabel('endNganjukTuri');
    tl.add(this.animatePath('hide', 'pasarturi-sidoarjo', 0.5), 'endSemarangTuri').addLabel('endTuriSidoarjo');

    tl.add(this.toggleLabel('hide', 'kediri', -5), 'start+=3.1');
    tl.add(this.toggleLabel('hide', 'tulungagung', 4), 'start+=3.2');
    tl.add(this.toggleLabel('hide', 'malang', null, 1), 'start+=3.3');
    tl.add(this.animatePath('hide', 'nganjuk-kediri'), 'endMadiunNganjuk+=0.1').addLabel('endNganjukKediri');
    tl.add(this.animatePath('hide', 'kediri-tulungagung'), 'endNganjukKediri').addLabel('endKediriTulungagung');
    tl.add(this.animatePath('hide', 'tulungagung-malang', 0.2), 'endKediriTulungagung').addLabel('endTulungagungMalang');
    tl.add(this.animatePath('hide', 'malang-sidoarjo'), 'endTulungagungMalang').addLabel('endMalangSidoarjo');

    tl.add(this.toggleLabel('hide', 'sidoarjo'), 'start+=3');
    tl.add(this.toggleLabel('hide', 'pasuruan'), 'start+=3.1');
    tl.add(this.toggleLabel('hide', 'probolinggo'), 'start+=3.2');
    tl.add(this.toggleLabel('hide', 'jember'), 'start+=3.4');
    tl.add(this.toggleLabel('hide', 'banyuwangi'), 'start+=3.6');
    tl.add(this.animatePath('hide', 'sidoarjo-pasuruan', 0.3), 'endTuriSidoarjo').addLabel('endSidoarjoPasuruan');
    tl.add(this.animatePath('hide', 'pasuruan-probolinggo'), 'endSidoarjoPasuruan').addLabel('endPasuruanProbolinggo');
    tl.add(this.animatePath('hide', 'probolinggo-jember'), 'endPasuruanProbolinggo').addLabel('endProbolinggoJember');
    tl.add(this.animatePath('hide', 'jember-banyuwangi'), 'endProbolinggoJember').addLabel('endJemberBanyuwangi');

    return tl;
  }

  animatePath(mode, name, duration = 0.1) {
    const path = this.paths.find(x => x.name == '.path.' + name);

    return gsap.to(path.name, {
      strokeDashoffset: mode == 'show' ? 0 : path.length * -1,
      duration,
      onComplete: () => {
        if (mode == 'hide') {
          gsap.set(path.name, {
            strokeDashoffset: path.length
          })
        }
      }
    })
  }

  toggleLabel(mode, name, x=null, y=null, duration=0.2) {
    let tl = gsap.timeline();
    tl.addLabel('start' + name);
    tl.to(['.circle.'+name, '.label.'+name], { opacity: mode == 'show' ? 1 : 0, duration });

    if (x) {
      tl.to('.label.' + name, { translateX: mode == 'show' ? 0 : x, duration }, 'start' + name);
    }
    if (y) {
      tl.to('.label.' + name, { translateY: mode == 'show' ? 0 : y, duration }, 'start' + name);
    }
    return tl;
  }
}
